import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../Components/Header";
import CartService from "../../Services/CartService";

const headerLinks = [{ name: "Home", href: "/" }];

export default function PaymentSuccess() {
  const [cartItemCount, setCartItemCount] = useState(0);
    const location = useLocation();
    const { amount, transactionId, paymentMethod } = location.state || {};

      // Fetch the cart count initially
  const fetchCartCount = async () => {
    try {
      const { CartCount } = await CartService.GetCartCount();
      setCartItemCount(CartCount);
    } catch (error) {
      console.error("Error fetching cart count:", error);
    }
  };

  useEffect(() => {
    fetchCartCount(); // Fetch cart count when the component mounts
  }, []);

  return (
    <><Header cartItemsCount={cartItemCount} title="" links={headerLinks} /><div className="flex flex-col justify-center items-center h-screen text-center bg-gray-50">
      <div className="flex flex-col justify-center items-center bg-white rounded-lg shadow-md p-10">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-6">
          <svg
            className="w-10 h-10 text-green-500"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9 12l2 2l4 -4" />
            <circle cx="12" cy="12" r="10" />
          </svg>
        </div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
          Payment Success!
        </h2>
        <p className="text-gray-600 mb-6">
          Your payment has been processed! Details of the transaction have been
          included below.
        </p>
        <div className="bg-gray-100 rounded-lg p-4 w-full max-w-md text-left mb-6">
          <div className="flex justify-between text-gray-800">
            <span>Amount:</span>
            <span className="font-semibold">${amount}</span>
          </div>
          <div className="flex justify-between text-gray-800">
            <span>Transaction ID:</span>
            <span className="font-semibold">{transactionId}</span>
          </div>
          {/* <div className="flex justify-between text-gray-800">
      <span>Payment Type:</span>
      <span className="font-semibold">{paymentMethod}</span>
    </div> */}
        </div>
        <button
          className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600 transition-colors"
          onClick={() => {
            // Add your redirection logic here
            window.location.href = "/myaccounts";
          } }
        >
          Home
        </button>
      </div>
    </div></>
  );
}
